import { memo, useMemo } from 'react';

import { Box, Text } from '@bonanza-social/moonlight';
import { useTranslation } from '@bonanza-social/i18n';
import { StatusMemberInstructionsProps } from './types';

function StatusMemberInstructions({ status }: StatusMemberInstructionsProps) {
  const { promotionNumberOfBoxes, nextPlayerStatus } = status;
  const [t] = useTranslation('status');

  const titleLocKey = useMemo(
    () =>
      promotionNumberOfBoxes === 1
        ? 'member_instructions_title_one'
        : 'member_instructions_title_other',
    [promotionNumberOfBoxes],
  );

  if (!nextPlayerStatus || !promotionNumberOfBoxes) {
    return null;
  }

  return (
    <Box
      flex={1}
      gap="space-400"
      backgroundColor="mutedBackground"
      alignItems="center"
      padding="space-300"
      borderRadius="radius-200"
    >
      <Box>
        <Text
          variant="caption"
          locNS="status"
          color="darkSurfaceTertiary"
          locKey="member_instructions_title_one"
          textAlign="center"
        >
          {t(titleLocKey, { numberOfBoxes: promotionNumberOfBoxes })}
        </Text>
        <Text
          variant="caption-semi"
          locNS="status"
          gradient={`darkSurfaceStatus${nextPlayerStatus}`}
          locKey={nextPlayerStatus}
          textAlign="center"
        />
      </Box>
      <Text variant="caption" color="darkSurfaceTertiary" textAlign="center">
        {t('member_instructions_message', { nextStatus: nextPlayerStatus })}
      </Text>
    </Box>
  );
}

export default memo(StatusMemberInstructions);
